import { useEffect } from 'react';

/**
 * Set per-page SEO metadata: <title>, <meta name="description">, and canonical link.
 * Restores previous values on unmount so SPA navigation doesn't leak stale meta.
 */
export function useSEO({ title, description, canonical } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl?.getAttribute('content');
    const canonicalEl = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonicalEl?.getAttribute('href');

    if (title) document.title = title;

    if (description) {
      if (descEl) {
        descEl.setAttribute('content', description);
      } else {
        const el = document.createElement('meta');
        el.setAttribute('name', 'description');
        el.setAttribute('content', description);
        document.head.appendChild(el);
      }
    }

    if (canonical) {
      if (canonicalEl) {
        canonicalEl.setAttribute('href', canonical);
      } else {
        const el = document.createElement('link');
        el.setAttribute('rel', 'canonical');
        el.setAttribute('href', canonical);
        document.head.appendChild(el);
      }
    }

    return () => {
      if (title) document.title = prevTitle;
      if (description && descEl && prevDesc != null) descEl.setAttribute('content', prevDesc);
      if (canonical && canonicalEl && prevCanonical != null) canonicalEl.setAttribute('href', prevCanonical);
    };
  }, [title, description, canonical]);
}
